import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n  padding-left: 16px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n  padding: 12px 0;\n  min-height: 62px;\n  box-sizing: border-box;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Bodytext, Heading2, Footnote } from '../Typography';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject());
var Item = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.ivory;
});
var RightSide = styled.div(_templateObject3());
export var SummaryFrame = function SummaryFrame(_ref) {
  var rows = _ref.rows;
  return /*#__PURE__*/React.createElement(Container, null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement(Item, {
      key: i
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading2, null, row.label)), /*#__PURE__*/React.createElement(RightSide, null, typeof row.value === 'string' ? /*#__PURE__*/React.createElement(Bodytext, null, row.value) : row.value, row.subtext && /*#__PURE__*/React.createElement(Footnote, null, row.subtext)));
  }));
};